module.exports = __webpack_public_path__ + "static/presets-705907daff55c5581fe2e0175d08f653.png";